export const reducerCases = {
  SET_CONVERSATIONS: "SET_CONVERSATIONS",
  APPEND_CONVERSATIONS: "APPEND_CONVERSATIONS",
  SET_CONVERSATIONS_META: "SET_CONVERSATIONS_META",
  SET_CONVERSATIONS_TOTAL_COUNT: "SET_CONVERSATIONS_TOTAL_COUNT",
  SUMAR: "SUMAR",
  RESTAR: "RESTAR",
  SET_CURRENT_PHONE: "SET_CURRENT_PHONE",
  ADD_MESSAGES_TO_CONVERSATION: "ADD_MESSAGES_TO_CONVERSATIONS",
  SET_ALL_CONTACTS_PAGE: "SET_ALL_CONTACTS_PAGE",
  CONTACT_SEARCH: "CONTACT_SEARCH",
  SET_USER_CONTACTS: "SET_USER_CONTACTS",
  SET_SOCKET: "SET_SOCKET",
  UPDATE_UNREAD_MESSAGE: "UPDATE_UNREAD_MESSAGE",
  UPDATE_CONVERSATION_PINNED: "UPDATE_CONVERSATION_PINNED",
  CHAT_LIST_PAGE: "CHAT_LIST_PAGE",
  SET_MOBILE: "SET_MOBILE",
  MOVE_CONTACT: "MOVE_CONTACT",
  SET_FILE_CHAT: "SET_FILE_CHAT",
  SET_USER_INFO: "SET_USER_INFO",
  CLOSE_CHAT: "CLOSE_CHAT",
  SET_REPLY_MESSAGE: "SET_REPLY_MESSAGE",
  CLEAR_REPLY_MESSAGE: "CLEAR_REPLY_MESSAGE",
  ADD_PREVIOUS_MESSAGES_TO_CONVERSATION:
    "ADD_PREVIOUS_MESSAGES_TO_CONVERSATION",
  SET_CHAT_EXPIRED: "SET_CHAT_EXPIRED",
  SET_ASSIGNED_AGENT: "SET_ASSIGNED_AGENT",
  SET_NOTE_ALERT: "SET_NOTE_ALERT",
  CLEAR_NOTE_ALERT: "CLEAR_NOTE_ALERT",
  SET_GLOBAL_STATUS: "SET_GLOBAL_STATUS",
  SET_CONNECTED_AGENTS: "SET_CONNECTED_AGENTS",
  UPDATE_MESSAGE_ERROR: "UPDATE_MESSAGE_ERROR",
  CLEAR_MESSAGE_ERROR: "CLEAR_MESSAGE_ERROR",
  UPDATE_DATE_CONTROL: "UPDATE_DATE_CONTROL",
  SET_ACTIVE_FILTERS: "SET_ACTIVE_FILTERS",
  SET_LOADING_CONVERSATIONS: "SET_LOADING_CONVERSATIONS", // Nueva constante
  SET_TAGS_PAGE: "SET_TAGS_PAGE", // Para mostrar la página de etiquetas
  SET_ACTIVE_LIST_FILTER: "SET_ACTIVE_LIST_FILTER", // all|unread|favorites|tags
  SET_ACTIVE_TAG_FILTER: "SET_ACTIVE_TAG_FILTER", // tagId | null
  CHANGE_CURRENT_CHAT_USER: "CHANGE_CURRENT_CHAT_USER", // Cambiar usuario actual
  SET_MESSAGES: "SET_MESSAGES", // Establecer mensajes
  SET_TARGET_MESSAGE_ID: "SET_TARGET_MESSAGE_ID", // ID del mensaje objetivo para scroll
  UPDATE_CONVERSATION_TAG: "UPDATE_CONVERSATION_TAG", // Actualizar tag de una conversación específica
  UPDATE_MESSAGE_REACTIONS: "UPDATE_MESSAGE_REACTIONS", // Actualizar reacciones de un mensaje
  UPDATE_CONVERSATION_UNREAD: "UPDATE_CONVERSATION_UNREAD", // Actualizar contador de mensajes no leídos
  UPDATE_MESSAGE_STATUS: "UPDATE_MESSAGE_STATUS", // Actualizar estado del mensaje (sent, delivered, read, failed)
  SET_FORWARD_MESSAGE: "SET_FORWARD_MESSAGE", // Establecer mensaje a reenviar
  CLEAR_FORWARD_MESSAGE: "CLEAR_FORWARD_MESSAGE", // Limpiar mensaje a reenviar
  UPDATE_CONVERSATION: "UPDATE_CONVERSATION", // Actualizar una conversación individual sin perder mensajes cargados
  ADD_OR_UPDATE_CONTACT: "ADD_OR_UPDATE_CONTACT", // Agregar o actualizar un contacto en userContacts sin tocar conversations
  SET_TYPING_USER: "SET_TYPING_USER", // Indicador de que un agente está escribiendo
  SET_CRM_OPEN: "SET_CRM_OPEN",
  SET_CRM_VIEW: "SET_CRM_VIEW",
};
